import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout';
import { createEntry } from '@atlassian/jira-router';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global';
import { globalSettingsSystemRolesActorsUsersRoute } from '@atlassian/jira-router-routes-legacy-global-settings-system-roles-actors-users-routes';

export const globalSettingsSystemRolesActorsUsersRouteEntry = createEntry(
	globalSettingsSystemRolesActorsUsersRoute,
	{
		layout: globalSettingsLayout,
		resources: [navigationSidebarGlobalResource],
	},
);
